import Page from '../page';

import { gradient } from "./gradient";
import { dot } from "./dot";
import { core } from "./core";
import { relate } from "./relate";

export default class ServiceManager extends Page {
	constructor() {
		super();
	}
	init() {
		gradient(this);
		dot(this);
		core(this);
		relate(this);

		this.scroll();
		this.resize();
		window.dispatchEvent(new Event('resize'))
	}
	scroll() {
		document.addEventListener('scroll', () => {

		});
	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}